module.exports = __webpack_public_path__ + "static/media/curling.971a4318.svg";